import { consumer } from '@tock/coretypes';
import { getBaseFormFieldsInitialValues, useUpdateNamedConfigurations } from '../widgetFormUtils';
import MarketingFeatureNamedConfigurationForm, {
  MarketingFeatureFormFields,
} from './MarketingFeatureNamedConfigurationForm';

interface Props {
  selectedWidgetToEdit?: consumer.NamedConfiguration;
  onCompleteOrCancel(): void;
}

const getInitialValues = (editWidget: consumer.NamedConfiguration): MarketingFeatureFormFields => {
  return {
    ...getBaseFormFieldsInitialValues({ widgetToEdit: editWidget }),
    tiles: editWidget.marketingFeaturesWidgetConfig?.tile || [],
  };
};

const UpdateMarketingFeatureWidgetForm: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  onCompleteOrCancel,
  selectedWidgetToEdit,
}) => {
  const updateNamedConfig = useUpdateNamedConfigurations();

  const handleSubmit = ({ tiles }: MarketingFeatureFormFields) => {
    return updateNamedConfig({
      ...selectedWidgetToEdit,
      marketingFeaturesWidgetConfig: { tile: tiles },
    }).then(onCompleteOrCancel);
  };

  if (!selectedWidgetToEdit) {
    return null;
  }

  return (
    <MarketingFeatureNamedConfigurationForm
      initialValues={getInitialValues(selectedWidgetToEdit)}
      onSubmit={handleSubmit}
      onClear={onCompleteOrCancel}
      updatingConfig={selectedWidgetToEdit}
    />
  );
};

export default UpdateMarketingFeatureWidgetForm;
